import {FontFamilyMap, FontSizeType} from 'types/commons'

export const FONT_SIZE_MAP: Record<FontSizeType, number> = {
  xxl: 30,
  xl: 24,
  l: 18,
  m: 15,
  s: 12,
  xs: 10,
  xxs: 8,
}

export const FONT_LINE_HEIGHT_MAP: Record<FontSizeType, number> = {
  xxl: 41,
  xl: 36,
  l: 31,
  m: 26,
  s: 21,
  xs: 17,
  xxs: 14,
}

export const FONT_FAMILY_MAP: FontFamilyMap = {
  regular: 'Roboto-Regular',
  italic: 'Roboto-Italic',
  medium: 'Roboto-Medium',
  bold: 'Roboto-Bold',
  boldItalic: 'Roboto-BoldItalic',
  brand: 'ReemKufi-Regular',
  kalam: 'Kalam-Bold',
}
